import TransactionsIdentifier from './TransactionsIdentifier';
export default TransactionsIdentifier;
